//import projects
import Template from './Template';
import prompts from '../../../dummy_data/prompt_engineer/education.json';
// External variant
const options = ['Hướng nghiệp', 'Tìm hiểu về trường đại học', 'Kinh nghiệm thi cử'];

const prompt_persona_role = 'Phản hồi như một chuyên gia giáo dục toàn diện.';

export default function Education() {
    return (
        <Template personaRole={prompt_persona_role} data={prompts} title="Giáo dục" options={options} project="prompt_engineer/education" />
    );
}
